(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aq-collection"] && !Shopify.designMode) return;
  try {
    
(function(){
function initRange(root){
root.querySelectorAll('[data-aq-price-range]').forEach(function(w){
if(w.dataset.init) return; w.dataset.init='1';
var mn=w.querySelector('[data-range-min]'), mx=w.querySelector('[data-range-max]'), nmn=w.querySelector('[data-num-min]'), nmx=w.querySelector('[data-num-max]'), fill=w.querySelector('.aq-price-range__fill'), max=parseFloat(w.dataset.max)||1;
function paint(){ var a=parseFloat(mn.value), b=parseFloat(mx.value); if(a>b){ var t=a; a=b; b=t; } fill.style.left=(a/max*100)+'%'; fill.style.right=(100-b/max*100)+'%'; }
function fromRange(commit){ var a=Math.min(parseFloat(mn.value),parseFloat(mx.value)), b=Math.max(parseFloat(mn.value),parseFloat(mx.value)); nmn.value=a>0?a:''; nmx.value=b<max?b:''; paint(); if(commit) nmn.dispatchEvent(new Event('change',{bubbles:true})); }
mn.addEventListener('input',function(){ fromRange(false); }); mx.addEventListener('input',function(){ fromRange(false); });
mn.addEventListener('change',function(){ fromRange(true); }); mx.addEventListener('change',function(){ fromRange(true); });
nmn.addEventListener('input',function(){ mn.value=nmn.value||0; paint(); }); nmx.addEventListener('input',function(){ mx.value=nmx.value||max; paint(); });
paint();
});
}
var run=function(){ initRange(document); };
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',run); else run();
document.addEventListener('shopify:section:load',function(e){ initRange(e.target); });
new MutationObserver(function(){ initRange(document); }).observe(document.documentElement,{childList:true,subtree:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aq-faq"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(e){ const sm=e.target.closest('[data-aq-faq][data-single] summary'); if(!sm) return; const d=sm.parentElement; const root=sm.closest('[data-aq-faq]'); if(!d.open){ root.querySelectorAll('details[open]').forEach(o=>{ if(o!==d) o.removeAttribute('open'); }); } });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aq-header"] && !Shopify.designMode) return;
  try {
    
(function(){
  function setup(){
    var h=document.querySelector('aq-header[data-sticky="true"]'); var g=document.getElementById('header-group');
    if(!h||!g){ return; }
    var sec=h.closest('.shopify-section');
    function measure(){ var off=0; for(var i=0;i<g.children.length;i++){ var el=g.children[i]; if(el===sec) break; if(el.classList.contains('aq-section-topbar')) off+=el.offsetHeight; } g.style.position='sticky'; g.style.top=(-off)+'px'; g.style.zIndex='60'; document.documentElement.style.setProperty('--aq-header-h', h.offsetHeight+'px'); }
    measure(); window.addEventListener('resize',measure); document.addEventListener('shopify:section:load',measure);
    var sc=document.querySelector('.page-wrapper'); var target=sc||window;
    function onScroll(){ var y=sc?sc.scrollTop:window.scrollY; h.classList.toggle('is-scrolled', y>10); }
    target.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',setup); else setup();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
